<template>
  <div id="app" :class="{rtl: direction === 'rtl', ltr: direction === 'ltr', 'disable-pull-to-refresh': true}">

    <!-- <transition name="router-anim" enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutDown"> -->
      <router-view/>
    <!-- </transition> -->

    <snackbar/>

    <modal v-if="showLogin" v-show="showLogin" @close="hideLoginDialog" />
    <shareModal v-if="isShareModalVisible" v-show="isShareModalVisible"/>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import snackbar from "./components/snackbar";

// import permission from "./components/permission";

const shareModal = () =>
  import(/* webpackChunkName: "shareModal" */ "./components/shareModal");

const modal = () =>
  import(/* webpackChunkName: "logingDialog" */ "logingDialog");

module.exports = {
  components: {
    modal,
    shareModal,
    snackbar
  },
  data() {
    return {
      direction: "ltr"
    };
  },
  computed: {
    ...mapState(["showLogin", "isShareModalVisible"])
  },
  methods: {
    ...mapActions(["hideLoginDialog"])
  },
  async mounted() {
    const self = this;
    this.direction = this.$i18n.locale === "he-IL" ? "rtl" : "ltr";
    // this.direction = this.$i18n.locale === "he" ? "rtl" : "ltr";
    window.onpopstate = function() {
      if (window.location.hash !== "#login") {
        self.closeModal();
      }
    };
  }
};
</script>
<style>
/* @import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1"; */
.page {
  /* position: fixed; */
  width: 100%;
  background-color: #fff;
  max-width: 1000px;
  height: 100%;
}
.animated {
  animation-duration: 500ms;
}
</style>